export default __webpack_public_path__ + "static/media/tuna.08f57054.PNG";